import React, { useState } from "react"
import { observer } from "mobx-react"
import { Button, Flex, Form, Input, Typography } from "antd"
import { useForm } from "antd/es/form/Form"

import crystal from "@src/app/assets/crystal-white.png"
import crystalRetina from "@src/app/assets/crystal-white@2x.png"
import { FormContainer } from "@src/app/components/FormContainer"
import { Logo } from "@src/app/components/Logo"
import UiStore from "@src/app/uiStore"
import { useCatchFormErrors } from "@src/shared/form/base_error"
import css from "./index.module.css"
import { RecoveryConfirmStore } from "./store"

const { Item } = Form

const { Paragraph, Title } = Typography

export const PasswordRecoveryConfirmPage = observer(() => {
  const [store] = useState(new RecoveryConfirmStore())
  const { isTransferioTheme } = UiStore()

  const { recoverConfirm } = store
  const [form] = useForm()

  return (
    <Flex
      align={"center"}
      className={css.container}
      justify={isTransferioTheme ? "center" : "space-between"}
    >
      <Flex vertical>
        {!isTransferioTheme && <Logo size="full" />}

        <Typography className={css.typography}>
          <Title>Password recovery</Title>
          <Paragraph>
            Please, enter code from your email and new password
          </Paragraph>
        </Typography>
        <FormContainer
          form={form}
          name="register"
          onFinish={() => recoverConfirm(form.getFieldsValue())}
        >
          <Flex gap={20} vertical>
            <Item
              label="Email"
              name="email"
              rules={[
                {
                  message: "Must be a valid email address",
                  type: "email",
                },
                {
                  message: "Please input your Email",
                  required: true,
                },
              ]}
            >
              <Input />
            </Item>
            <Item
              label="Code"
              name="code"
              rules={[
                {
                  message: "Please input your code",
                  required: true,
                },
              ]}
            >
              <Input />
            </Item>
            <Item
              hasFeedback
              label="Password"
              name="password"
              rules={[
                {
                  message: "Please input your password",
                  required: true,
                },
                {
                  message: "The length must be no less than 8 characters",
                  min: 8,
                },
              ]}
            >
              <Input.Password />
            </Item>
            <Item
              dependencies={["password"]}
              hasFeedback
              label="Confirm Password"
              name="confirm_password"
              rules={[
                {
                  message: "Please confirm your password",
                  required: true,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve()
                    }

                    return Promise.reject(new Error("Does not match password"))
                  },
                }),
              ]}
            >
              <Input.Password />
            </Item>

            <Item>
              <Button
                className={css.button}
                htmlType="submit"
                id="GENERATED_ID_PASSWORDRECOVERYCONFIRM_BUTTON_SAVE_NEW_PASSWORD_1"
                type="primary"
              >
                Save new password
              </Button>
            </Item>
          </Flex>
        </FormContainer>
      </Flex>
      {!isTransferioTheme && (
        <div className={css.rightSide}>
          <img
            alt="crystal"
            className={css.crystal}
            src={crystal}
            srcSet={`${crystalRetina} 2x`}
          />
        </div>
      )}
    </Flex>
  )
})
